export function normalizePathname(pathname) {
  const map = {
    '/collections/yogamatten': '/collections/yogamatten',
    '/collections/yogamatten-fur-zuhause': '/collections/yogamatten',
    '/collections/rutschfeste-yogamatten': '/collections/yogamatten',
    '/collections/studio-yogamatten': '/collections/yogamatten',
    '/collections/reise-yogamatten': '/collections/yogamatten',
    '/collections/meditationskissen': '/collections/meditationskissen',
    '/collections/rundkissen': '/collections/meditationskissen',
    '/collections/zafu-kissen': '/collections/meditationskissen',
    '/collections/halbmondkissen': '/collections/meditationskissen',
  };

  return map[pathname] || null;
}
